import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {HttpClientModule} from '@angular/common/http';
import {IconService} from './icon.service';

@NgModule({
  imports: [CommonModule, MatIconModule, HttpClientModule],
})
export class IconsModule {
  constructor(private iconService: IconService) {
    this.iconService
      .addSvgIcon('home', './assets/icons/home.svg')
      .addSvgIcon('accessibility', './assets/icons/accessibility.svg')
      .addSvgIcon('documents', './assets/icons/documents.svg')
      .addSvgIcon('image_alts', './assets/icons/image_alts.svg')
      .addSvgIcon('resellers', './assets/icons/resellers.svg')
      .addSvgIcon('resources', './assets/icons/resources.svg')
      .addSvgIcon('scanner', './assets/icons/scanner.svg')
      .addSvgIcon('settings', './assets/icons/settings.svg')
      .addSvgIcon('settings_white', './assets/icons/settings_white.svg')
      .addSvgIcon('design_audit', './assets/icons/design_audit.svg')
      .addSvgIcon('audits', './assets/icons/audits.svg')
      .addSvgIcon('download', './assets/icons/download.svg')
      .addSvgIcon('video', './assets/icons/video.svg')
      .addSvgIcon('vpat', './assets/icons/vpat.svg')
      .addSvgIcon('vpat-blue', './assets/icons/vpat-blue.svg')
      .addSvgIcon('triangle_right', './assets/icons/triangle_right.svg')
      .addSvgIcon('triangle', './assets/icons/triangle.svg')
      .addSvgIcon('cross_fill', './assets/icons/x.svg')
      .addSvgIcon('all_sites', './assets/icons/all_sites.svg')
      .addSvgIcon('search', './assets/icons/search.svg')
      .addSvgIcon('arrow_blue_right', './assets/icons/arrow_blue_right.svg')
      .addSvgIcon('check', './assets/icons/check.svg')
      .addSvgIcon('check-green', './assets/icons/check-green.svg')
      .addSvgIcon('check-blue', './assets/icons/check-blue.svg')
      .addSvgIcon('cross', './assets/icons/cross.svg')
      .addSvgIcon('cross-red', './assets/icons/cross-red.svg')
      .addSvgIcon('cross-black', './assets/icons/cross-black.svg')
      .addSvgIcon('arrow_back_fill', './assets/icons/arrow_back_fill.svg')
      .addSvgIcon('ai_fill', './assets/icons/ai_fill.svg')
      .addSvgIcon('link_fill', './assets/icons/link_fill.svg')
      .addSvgIcon('arrow_blue_right', './assets/icons/arrow_blue_right.svg')
      .addSvgIcon('arrow_right_black', './assets/icons/arrow_right_black.svg')
      .addSvgIcon('arrow_white_right', './assets/icons/arrow_white_right.svg')
      .addSvgIcon('new-payment', './assets/icons/new-payment.svg')
      .addSvgIcon('widget', './assets/icons/widget.svg')
      .addSvgIcon('plus_outline', './assets/icons/plus_outline.svg')
      .addSvgIcon('plus_outline_white', './assets/icons/plus_outline_white.svg')
      .addSvgIcon('plus', './assets/icons/plus.svg')
      .addSvgIcon('plus-simple-white', './assets/icons/plus-simple-white.svg')
      .addSvgIcon('bell', './assets/icons/bell.svg')
      .addSvgIcon('bell_white', './assets/icons/bell_white.svg')
      .addSvgIcon('drag', './assets/icons/drag.svg')
      .addSvgIcon('tip-right', './assets/icons/tip-right.svg')
      .addSvgIcon('trash', './assets/icons/trash.svg')
      .addSvgIcon('bell', './assets/icons/bell.svg')
      .addSvgIcon('accessibility_site', './assets/icons/accessibility-site.svg')
      .addSvgIcon('compliance_site', './assets/icons/compliance-site.svg')
      .addSvgIcon('high_risk', './assets/icons/high-risk-site.svg')
      .addSvgIcon('low_risk', './assets/icons/low-risk-site.svg')
      .addSvgIcon('lawsuit-risk-low', './assets/icons/lawsuit-risk-low.svg')
      .addSvgIcon('lawsuit-risk-high', './assets/icons/lawsuit-risk-high.svg')
      .addSvgIcon('calendar', './assets/icons/calendar.svg')
      .addSvgIcon('alert', './assets/icons/alert.svg')
      .addSvgIcon('images', './assets/icons/images.svg')
      .addSvgIcon('images-red', './assets/icons/images-red.svg')
      .addSvgIcon('images-purple', './assets/icons/images-purple.svg')
      .addSvgIcon('media', './assets/icons/media.svg')
      .addSvgIcon('documents-blue', './assets/icons/documents-blue.svg')
      .addSvgIcon('bento', './assets/icons/bento.svg')
      .addSvgIcon('calendar', './assets/icons/calendar.svg')
      .addSvgIcon('chips-tick', './assets/icons/chips-tick.svg')
      .addSvgIcon('chips-tick-white', './assets/icons/chips-tick-white.svg')
      .addSvgIcon('chips-remove', './assets/icons/chips-remove.svg')
      .addSvgIcon('pros', './assets/icons/pros.svg')
      .addSvgIcon('cons', './assets/icons/cons.svg')
      .addSvgIcon('uw-shield', './assets/icons/uw-shield.svg')
      .addSvgIcon('uw-shield-managed', './assets/icons/uw-shield-managed.svg')
      .addSvgIcon('performance', './assets/icons/performance.svg')
      .addSvgIcon('arrow-right', './assets/icons/arrow-right.svg')
      .addSvgIcon('man', './assets/icons/man.svg')
      .addSvgIcon('performance', './assets/icons/performance.svg')
      .addSvgIcon('bento', './assets/icons/bento.svg')
      .addSvgIcon('image_alts_1', './assets/icons/image_alts_1.svg')
      .addSvgIcon('image_alts_2', './assets/icons/image_alts_2.svg')
      .addSvgIcon('image_alts_3', './assets/icons/image_alts_3.svg')
      .addSvgIcon('image_alts_4', './assets/icons/image_alts_4.svg')
      .addSvgIcon('share', './assets/icons/share.svg')
      .addSvgIcon('copy', './assets/icons/copy.svg')
      .addSvgIcon('ai-modified', './assets/icons/ai-modified.svg')
      .addSvgIcon('alt-modified', './assets/icons/alt-modified.svg')
      .addSvgIcon('free-agency', './assets/icons/Free.svg')
      .addSvgIcon('invoice-agency', './assets/icons/Invoice.svg')
      .addSvgIcon('postpaid-agency', './assets/icons/Postpaid.svg')
      .addSvgIcon('prepaid-agency', './assets/icons/Prepaid.svg')
      .addSvgIcon('total-agency', './assets/icons/Total.svg')
      .addSvgIcon('logo-white', './assets/icons/logo-white.svg')
      .addSvgIcon('alt-modified', './assets/icons/alt-modified.svg')
      .addSvgIcon('chart', './assets/icons/chart.svg')
      .addSvgIcon('embed_code', './assets/icons/embed_code.svg')
      .addSvgIcon('play', './assets/icons/play.svg')
      .addSvgIcon('chart', './assets/icons/chart.svg')
      .addSvgIcon('alt-modified', './assets/icons/alt-modified.svg')
      .addSvgIcon('share', './assets/icons/share.svg')
      .addSvgIcon('copy', './assets/icons/copy.svg')
      .addSvgIcon('copy_black', './assets/icons/copy-black.svg')
      .addSvgIcon('chart', './assets/icons/chart.svg')
      .addSvgIcon('add_photo', './assets/icons/add_photo.svg')
      .addSvgIcon('star', './assets/icons/star.svg')
      .addSvgIcon('drag_photo', './assets/icons/drag_photo.svg')
      .addSvgIcon('2column', './assets/icons/2column.svg')
      .addSvgIcon('oversized', './assets/icons/oversized.svg')
      .addSvgIcon('sort', './assets/icons/sort.svg')
      .addSvgIcon('sort_down_active', './assets/icons/sort_down_active.svg')
      .addSvgIcon('sort_up_active', './assets/icons/sort_up_active.svg')
      .addSvgIcon('managed', './assets/icons/managed.svg')
      .addSvgIcon('info', './assets/icons/info.svg')
      .addSvgIcon('info-border', './assets/icons/info-border.svg')
      .addSvgIcon('lock', './assets/icons/lock.svg')
      .addSvgIcon('preview', './assets/icons/preview.svg')
      .addSvgIcon('ai', './assets/icons/ai.svg')
      .addSvgIcon('ai-fill', './assets/icons/ai-fill.svg')
      .addSvgIcon('twisted', './assets/icons/twisted.svg')
      .addSvgIcon('warning', './assets/icons/warning.svg')
      .addSvgIcon('uw-product-logo', './assets/icons/uw-product-logo.svg')
      .addSvgIcon('unfamiliar_sites', './assets/icons/unfamiliar_sites.svg')
      .addSvgIcon('external_link', './assets/icons/external_link.svg')
      .addSvgIcon('check-in-circle', './assets/icons/check-in-circle.svg')
      .addSvgIcon('message_checked', './assets/icons/message_checked.svg')
      .addSvgIcon('table_failed', './assets/icons/table_failed.svg')
      .addSvgIcon('site', './assets/icons/site.svg')
      .addSvgIcon('actions', './assets/icons/actions.svg')
      .addSvgIcon('copy_code', './assets/icons/copy_code.svg')
      .addSvgIcon('play_white', './assets/icons/play_white.svg')
      .addSvgIcon('copy_link', './assets/icons/copy_link.svg')
      .addSvgIcon('down_blue', './assets/icons/down_blue.svg')
      .addSvgIcon('agency', './assets/icons/agency.svg')
      .addSvgIcon('copy_code', './assets/icons/copy_code.svg')
      .addSvgIcon('play_white', './assets/icons/play_white.svg')
      .addSvgIcon('copy_link', './assets/icons/copy_link.svg')
      .addSvgIcon('down_blue', './assets/icons/down_blue.svg')
      .addSvgIcon('support', './assets/icons/support.svg')
      .addSvgIcon('support_cancelation', './assets/icons/support_cancelation.svg')
      .addSvgIcon('userway', './assets/icons/userway.svg')
      .addSvgIcon('phone', './assets/icons/phone.svg')
      .addSvgIcon('credit_card', './assets/icons/credit_card.svg')
      .addSvgIcon('bell_crossed', './assets/icons/bell_crossed.svg')
      .addSvgIcon('mail', './assets/icons/mail.svg')
      .addSvgIcon('arrow', './assets/icons/arrow.svg')
      .addSvgIcon('arrow-blue', './assets/icons/arrow-blue.svg')
      .addSvgIcon('header-logo', './assets/icons/header-logo.svg')
      .addSvgIcon('header-logo-aa', './assets/icons/header-logo-aa.svg')
      .addSvgIcon('ultimate', './assets/icons/ultimate.svg')
      .addSvgIcon('free-plan', './assets/icons/free-plan.svg')
      .addSvgIcon('pro', './assets/icons/pro.svg')
      .addSvgIcon('pro_plus', './assets/icons/pro_plus.svg')
      .addSvgIcon('scanner_white', './assets/icons/scanner-white.svg')
      .addSvgIcon('regulation', './assets/icons/regulation.svg')
      .addSvgIcon('regulation-white', './assets/icons/regulation-white.svg')
      .addSvgIcon('triangle-down', './assets/icons/triangle-down.svg')
      .addSvgIcon('link-lp', './assets/icons/link-lp.svg')
      .addSvgIcon('file', './assets/icons/file.svg')
      .addSvgIcon('fix-my-code_black', './assets/icons/fix-my-code_black.svg')
      .addSvgIcon('fix-my-code_white', './assets/icons/fix-my-code_white.svg')
      .addSvgIcon('mastercard', './assets/icons/mastercard.svg')
      .addSvgIcon('beta_label', './assets/icons/beta_label.svg')
      .addSvgIcon('beta_label_white', './assets/icons/beta_label_white.svg')
      .addSvgIcon('amex', './assets/icons/amex.svg')
      .addSvgIcon('arrow-right-blue', './assets/icons/arrow-right-blue.svg')
      .addSvgIcon('amex', './assets/icons/amex.svg')
      .addSvgIcon('license', './assets/icons/license.svg')
      .addSvgIcon('column-icon', './assets/icons/column-icon.svg')
      .addSvgIcon('header-logo_aa', './assets/icons/header-logo_aa.svg')
      .addSvgIcon('download-file', './assets/icons/download-file.svg')
      .addSvgIcon('accessible_pdf', './assets/icons/accessible_pdf.svg')
      .addSvgIcon('automated', './assets/icons/automated.svg')
      .addSvgIcon('inaccessible_pdf', './assets/icons/inaccessible_pdf.svg')
      .addSvgIcon('back-to-top', './assets/icons/back-to-top.svg')
      .addSvgIcon('info-button', './assets/icons/info-button.svg')
      .addSvgIcon('unionpay', './assets/icons/unionpay.svg')
      .addSvgIcon('dev-resources', './assets/icons/code.svg')
      .addSvgIcon('dev-resources_white', './assets/icons/code_white.svg')
      .addSvgIcon('dots', './assets/icons/dots.svg')
      .addSvgIcon('link', './assets/icons/link.svg')
      .addSvgIcon('new-card', './assets/icons/new-card.svg')
      .addSvgIcon('lt_icon_globe', './assets/icons/lt_icon_globe.svg')
      .addSvgIcon('lt_icon_translation', './assets/icons/lt_icon_translation.svg')
      .addSvgIcon('lt_icon_flag', './assets/icons/lt_icon_flag.svg')
      .addSvgIcon('ultimate-pic', './assets/icons/ultimate-pic.svg')
      .addSvgIcon('pro-pic', './assets/icons/pro-pic.svg')
      .addSvgIcon('pro-plus-pic', './assets/icons/pro-plus-pic.svg')
      .addSvgIcon('w3c', './assets/icons/w3c.svg')
      .addSvgIcon('w3c-red', './assets/icons/w3c-red.svg')
      .addSvgIcon('google', './assets/icons/google.svg')
      .addSvgIcon('lock-forbidden', './assets/icons/lock-forbidden.svg')
      .addSvgIcon('minus-collapse', './assets/icons/minus.svg')
      .addSvgIcon('plus-collapse', './assets/icons/plus.svg')
      .addSvgIcon('arrow-blue-left', './assets/icons/arrow_blue_left.svg')
      .addSvgIcon('arrow-blue-bottom', './assets/icons/arrow_blue_bottom.svg')
      .addSvgIcon('uw-audit', './assets/icons/uw-audit.svg')
      .addSvgIcon('uw-audit-active', './assets/icons/uw-audit-active.svg')
      .addSvgIcon('uw-managed', './assets/icons/uw-managed.svg')
      .addSvgIcon('uw-managed-active', './assets/icons/uw-managed-active.svg')
      .addSvgIcon('uw-microsoft', './assets/icons/uw-microsoft.svg')
      .addSvgIcon('uw-microsoft-active', './assets/icons/uw-microsoft-active.svg')
      .addSvgIcon('uw-pdf', './assets/icons/uw-pdf.svg')
      .addSvgIcon('uw-pdf-active', './assets/icons/uw-pdf-active.svg')
      .addSvgIcon('uw-scanner', './assets/icons/uw-scanner.svg')
      .addSvgIcon('uw-scanner-active', './assets/icons/uw-scanner-active.svg')
      .addSvgIcon('uw-training', './assets/icons/uw-training.svg')
      .addSvgIcon('uw-training-active', './assets/icons/uw-training-active.svg')
      .addSvgIcon('uw-widget', './assets/icons/uw-widget.svg')
      .addSvgIcon('sort-arrow-up', './assets/icons/sort-arrow-up.svg')
      .addSvgIcon('assistance', './assets/icons/assistance.svg')
      .addSvgIcon('shopify-logo', './assets/icons/shopify-logo.svg')
      .addSvgIcon('wix-logo', './assets/icons/wix-logo.svg')
      .addSvgIcon('plan-available', './assets/icons/plan-available.svg')
      .addSvgIcon('plan-not-available', './assets/icons/plan-not-available.svg')
      .addSvgIcon('alert-circle', './assets/icons/alert-circle.svg')
      .addSvgIcon('warning-info-icon', './assets/icons/warning-info-icon.svg')
      .addSvgIcon('members', './assets/icons/members.svg')
      .addSvgIcon('check-light-green', './assets/icons/check-light-green.svg')
      .addSvgIcon('uw-widget-active', './assets/icons/uw-widget-active.svg')
      .addSvgIcon('statement', './assets/icons/statement.svg')
      .addSvgIcon('level-access-logo-default', './assets/icons/level-access-logo-default.svg')
      .addSvgIcon('acc-statement', './assets/icons/acc-statement.svg')
      .addSvgIcon('no-groups', './assets/icons/no-groups.svg')
      .addSvgIcon('uw-pl-logo', './assets/icons/uw-pl-logo.svg')
      .addSvgIcon('discount-payment-link', './assets/icons/discount-payment-link.svg')
      .addSvgIcon('success-payment-link', './assets/icons/success-payment-link.svg')
      .addSvgIcon('ai-product', './assets/icons/ai-product.svg')
      .addSvgIcon('loading-blue', './assets/icons/loading-blue.svg')
      .addSvgIcon('account-manager', './assets/icons/account-manager-icon.svg')
      .addSvgIcon('support-service', './assets/icons/support-service.svg')
      .addSvgIcon('support-service_white', './assets/icons/support-service_white.svg')
      .addSvgIcon('export', './assets/icons/export.svg')
      .addSvgIcon('arrow-black-right', './assets/icons/arrow-black-right.svg')
      .addSvgIcon('info-blue', './assets/icons/info-blue.svg')
      .addSvgIcon('arrow-black-right', './assets/icons/arrow-black-right.svg')
      .addSvgIcon('upgrade-to-access', './assets/icons/upgrade_to_access.svg')
      .addSvgIcon('img-expired-trial', './assets/icons/img-expired-trial.svg')
      .addSvgIcon('alert-info-outline', './assets/icons/alert-info-outline.svg');
  }
}
